import React from 'react';

import './CompatibilityTagline.css';

export default () => (
    <p className="compatibility-tagline">
        Best viewed on Google Chrome, Microsoft Edge, or Mozilla Firefox<br />
        Ideal screen resolution of at least 1376x768
    </p>
);